import React from 'react'

const SvgOpenInNewTabFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M11.766 7.991A3 3 0 019.171 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-3.17a3 3 0 01-3.991-2.596l-1.888 1.887A3 3 0 119.88 9.88l1.887-1.888z' />
    <path d='M13 4a1 1 0 100 2h3.586l-5.293 5.293a1 1 0 001.414 1.414L18 7.414V11a1 1 0 102 0V5a1 1 0 00-1-1h-6z' />
  </svg>
)

export default SvgOpenInNewTabFilled
